import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {Bel} from "../../../../services/bel/bel/bel.model";
import {ApplicationEnum} from "@Common/widgets/general/attachments/interfaces/application.enum";
import {AttachmentModel} from "@Common/widgets/general/attachments/interfaces/attachment.model";
import {ObjectGeneric} from "@Common/widgets/general/object-generic-django.interface";

@Component({
  selector: 'app-piecejointe-form',
  templateUrl: './piecejointe-form.component.html',
  styleUrls: ['./piecejointe-form.component.scss']
})
export class PiecejointeFormComponent implements OnInit {
  uploadConnector: Subject<any> = new Subject();

  bordereau: Bel;

  application: ApplicationEnum = ApplicationEnum.archivage;
  typeFileButton: 'icon' | 'label' = 'label';
  alignFilesUpload: 'start' | 'end' = 'start';
  acceptFiles = '.pdf';
  maxFileSize = 5000000;
  maxFiles = 1;
  colorButton: 'accent' | 'primary' | 'warn' | undefined = undefined;
  uploading$: Subject<boolean> = new Subject<boolean>();
  hasAttachments = false;
  uploading = false;
  file_name_origin = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<PiecejointeFormComponent>) {

  }

  ngOnInit() {
    if (this.data) {
      this.bordereau = this.data;
    }
  }

  handleFinishUploadedFiles(pieceJointes: AttachmentModel[]) {
    this.closePopUp(pieceJointes[0]);
  }

  launchUpload() {
    const genericObj = <ObjectGeneric>{
      object_id: this.bordereau.id,
      content_type: this.bordereau.content_type,
      application: ApplicationEnum.archivage,
      filename_origin: this.file_name_origin,
    };
    this.uploadConnector.next(genericObj);

  }

  closePopUp(pj?: AttachmentModel) {
    this.dialogRef.close(pj);
  }

  hasAttachmentsToUpload(attachments: AttachmentModel[]) {
    this.hasAttachments = attachments.length > 0;
    if(this.hasAttachments){
      this.file_name_origin = attachments[0].name;
    }
  }

}
